import { useArtworkStore } from "@/store/artwork";

/** 权益刷新后同步通道；免费用户主动选择的加速通道必须保留。 */
export function syncArtworkChannel(hasPackages: boolean): void {
  const artwork = useArtworkStore();
  if (hasPackages) artwork.channel = "expedite";
  else if (artwork.channel !== "expedite") artwork.channel = "normal";
}
